import React from "react";
import { useTranslation } from "react-i18next";

// MUI Components
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel, { stepLabelClasses } from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";

// Styles
import styles from "./style.module.scss";
import { StepIconProps } from "@mui/material/StepIcon";

interface TrackingProps {
  currentStep: string;
  steps: string[];
}

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.root}`]: {
    maxHeight: '24px !important',
    minHeight: '24px !important',
    position: 'relative',
  },
  [`& .${stepConnectorClasses.line}`]: {
    border: 'none !important',
    width: '8px !important',
    minHeight: '48px !important',
    position: 'absolute',
    top: '-10px !important',
    zIndex: 1,
    backgroundColor: theme.palette.grey[400],
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primary.main,
    }
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primary.main,
    }
  }
}));

const CustomStepIcon: React.FC<StepIconProps> = ({ active, completed, className, icon }) => {
  return (
    <div className={`${styles.stepIcon} ${active && styles.stepIcon_active} ${completed && styles.stepIcon_completed} ${className}`}>
      <Typography variant="body1" color='secondary'>
        {icon}
      </Typography>
    </div>
  )
};

const Tracking: React.FC<TrackingProps> = ({ currentStep, steps }) => {
  // Translations
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <Stepper
        orientation="vertical"
        activeStep={steps.indexOf(currentStep)}
        nonLinear
        connector={<CustomStepConnector />}
      >
        {steps.map((step, index) => {
          return (
            <Step key={step} active={steps.indexOf(currentStep) >= index}>
              <StepLabel slots={{ stepIcon: CustomStepIcon }} icon={index + 1}>
                <Typography variant="body1">
                  {t(`courses.new.${step}.step`)}
                </Typography>
              </StepLabel>
            </Step>
          )
        })}
      </Stepper>
    </div>
  )
}

export default Tracking;
